module.exports = __webpack_public_path__ + "static/media/german_rocket_artillery_120.4cc39204.png";